(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 69840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoadingText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/helpers/misc/hexToRgba.ts
function hexToRgba(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    if (alpha === 0 || alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }
};

// EXTERNAL MODULE: ./src/components/LoadingText/styles.module.css
var styles_module = __webpack_require__(68732);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/LoadingText/index.tsx




function LoadingText(param) {
    var _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? 20 : _lineHeight, _lines = param.lines, lines = _lines === void 0 ? 1 : _lines, _widthPercentage = param.widthPercentage, widthPercentage = _widthPercentage === void 0 ? 100 : _widthPercentage, _useAnimationDelay = param.useAnimationDelay, useAnimationDelay = _useAnimationDelay === void 0 ? true : _useAnimationDelay, _color = param.color, color = _color === void 0 ? "#e0e0e0" : _color, _highlightColor = param.highlightColor, highlightColor = _highlightColor === void 0 ? "#f5f5f5" : _highlightColor;
    var ref = (0,react.useState)(0), animationDelay = ref[0], setAnimationDelay = ref[1];
    (0,react.useEffect)(function() {
        if (useAnimationDelay) setAnimationDelay(Math.random() * 0.5);
    }, [
        useAnimationDelay
    ]);
    var arr = Array.from(Array(lines).keys());
    var backgroundImage = "linear-gradient(90deg, ".concat(hexToRgba(highlightColor, 0), " 0, ").concat(hexToRgba(highlightColor, 0.2), " 20%, ").concat(hexToRgba(highlightColor, 0.5), " 60%, ").concat(hexToRgba(highlightColor, 0), ")");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: arr.map(function(key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).line,
                    style: {
                        height: lineHeight,
                        width: "".concat(widthPercentage, "%"),
                        backgroundColor: color
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).after,
                        style: {
                            animationDelay: "".concat(String(animationDelay).substring(0, 4), "s"),
                            backgroundImage: backgroundImage
                        }
                    })
                })
            }, key);
        })
    });
};


/***/ }),

/***/ 74207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getOutOfStockProductsInListQuery; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getOutOfStockProductsInList(\n    $websiteId: ID\n    $productsIds: [ID]\n    $storeId: ID\n    $deliverAt: Date\n  ) {\n    outOfStockIds: outOfStockProductsInList(\n      websiteId: $websiteId\n      productsIds: $productsIds\n      storeId: $storeId\n      deliverAt: $deliverAt\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getOutOfStockProductsInListQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 87714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ exactSearch; }
/* harmony export */ });
var hasAtLeastNumbers = function(phrase) {
    var numbers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
    var re = /\d/g;
    var repeats = ((phrase || "").match(re) || []).length;
    return repeats >= numbers;
};
var hashHyphens = function(phrase) {
    var indexOfHyphen = phrase.indexOf("-");
    return indexOfHyphen !== -1;
};
function exactSearch(phrase) {
    return hasAtLeastNumbers(phrase) || hashHyphens(phrase);
};


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ScrollTo; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var supportsNativeSmoothScroll = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function ScrollTo(param) {
    var element = param.element, _top = param.top, top = _top === void 0 ? 0 : _top, _left = param.left, left = _left === void 0 ? 0 : _left;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
        return;
    }
    element = (element === null || element === void 0 ? void 0 : element.scrollTo) && typeof (element === null || element === void 0 ? void 0 : element.scrollTo) === "function" ? element : window;
    if (!element) {
        return;
    }
    if (supportsNativeSmoothScroll) {
        element.scrollTo({
            top: top,
            left: left,
            behavior: "smooth"
        });
        return;
    }
    try {
        element.scrollTo(left, top);
    } catch (error) {
        try {
            element.scrollTop = top;
            element.scrollLeft = left;
        } catch (error) {}
    }
};


/***/ }),

/***/ 77712:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var sleep = function(time) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, time);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (sleep);


/***/ }),

/***/ 49343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsStore; }
});

;// CONCATENATED MODULE: ./src/helpers/websites/isStore.ts
function isStore(businessType) {
    return businessType === "store";
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./src/helpers/websites/getDomain.ts
var getDomain = __webpack_require__(15141);
;// CONCATENATED MODULE: ./src/helpers/misc/WebsiteBusinessTypeContext.ts

/* harmony default export */ var WebsiteBusinessTypeContext = (react.createContext(null));

// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/useApolloQuery.js
var useApolloQuery = __webpack_require__(28613);
var useApolloQuery_default = /*#__PURE__*/__webpack_require__.n(useApolloQuery);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteBusinessType.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteBusinessTypeFromDomain_cached($domain: String) {\n        website(domain: $domain) {\n          _id\n          businessType\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useWebsiteBusinessType() {
    var businessType = (0,react.useContext)(WebsiteBusinessTypeContext);
    var website = useApolloQuery_default()({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            domain: (0,getDomain/* default */.Z)()
        },
        fetchPolicy: "cache-first",
        omit: (0,isServerSide/* default */.Z)(),
        partial: true
    }).website;
    if (businessType) return businessType;
    if (!website || !(0,getDomain/* default */.Z)()) return null;
    return website.businessType;
};

;// CONCATENATED MODULE: ./src/hooks/useIsStore.ts


function useIsStore(website) {
    var businessType = useWebsiteBusinessType();
    if (website === null || website === void 0 ? void 0 : website.businessType) {
        businessType = website.businessType;
    }
    return isStore(businessType);
};


/***/ }),

/***/ 50153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90257);


var useIsomorphicLayoutEffect = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 6991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Filters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18783);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _packages_justo_parts_lib_components_fields_Select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97338);
/* harmony import */ var simple_react_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40191);
/* harmony import */ var simple_react_form__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(simple_react_form__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12284);







var encode = function(val) {
    return JSON.stringify(val, null, 2);
};
var parse = function(val) {
    return JSON.parse(val);
};
var options = [
    {
        value: JSON.stringify(null),
        label: "Destacados"
    },
    {
        value: encode({
            type: "price",
            order: "asc"
        }),
        label: "Precio menor a mayor"
    },
    {
        value: encode({
            type: "price",
            order: "desc"
        }),
        label: "Precio mayor a menor"
    },
    {
        value: encode({
            type: "name",
            order: "asc"
        }),
        label: "Ordenar A - Z"
    },
    {
        value: encode({
            type: "name",
            order: "desc"
        }),
        label: "Ordenar Z - A"
    }
];
function Filters(props) {
    var sorting = props.sorting, setSorting = props.setSorting, additionalClassname = props.additionalClassname;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.products.productsContent.filters"
    }).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container), additionalClassname ? additionalClassname : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().order),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simple_react_form__WEBPACK_IMPORTED_MODULE_3__.Field, {
                fieldName: "",
                placeholder: t("labelSort"),
                onChange: function(val) {
                    return setSorting(parse(val));
                },
                value: encode(sorting),
                type: _packages_justo_parts_lib_components_fields_Select__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                options: options
            })
        })
    });
};


/***/ }),

/***/ 85872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/misc/hasWebpSupport.ts
var hasWebpSupport = __webpack_require__(6909);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/helpers/misc/getQueryObject.ts
var getQueryObject = __webpack_require__(62280);
// EXTERNAL MODULE: ./src/helpers/misc/scrollTo.ts
var misc_scrollTo = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withScroll.js
var withScroll = __webpack_require__(7018);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx
var StoreName = __webpack_require__(59450);
// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts + 1 modules
var useDebounce = __webpack_require__(1003);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(50153);
// EXTERNAL MODULE: ./src/hooks/useKeyboardEvent.ts
var useKeyboardEvent = __webpack_require__(1626);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(12284);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Bar/styles.module.css
var styles_module = __webpack_require__(42653);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Bar/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














function Bar(props) {
    var filter = props.filter, setFilter = props.setFilter;
    var ref3 = _slicedToArray((0,useState/* default */.Z)(filter), 2), localSearch = ref3[0], setLocalSearch = ref3[1];
    var ref1 = _slicedToArray((0,useState/* default */.Z)(false), 2), searching = ref1[0], setSearching = ref1[1];
    var input = (0,useRef/* default */.Z)(null);
    var t = (0,esm/* useTranslation */.$G)("website").t;
    var router = (0,next_router.useRouter)();
    var ref2 = _slicedToArray((0,useDebounce/* default */.Z)(localSearch, 400), 2), debouncedFilter = ref2[0], isDebouncing = ref2[1];
    (0,useKeyboardEvent/* default */.Z)("Escape", function() {
        setSearching(false);
    });
    (0,react.useEffect)(function() {
        var ref;
        var q = (ref = (0,getQueryObject/* default */.Z)(router)) === null || ref === void 0 ? void 0 : ref.search;
        var qValue = Array.isArray(q) ? q[0] : q;
        if (qValue !== "" && filter !== qValue) {
            setFilter(qValue);
            setLocalSearch(qValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // We want to do this only on load
    ;
    (0,react.useEffect)(function() {
        if (debouncedFilter !== filter) {
            var ref;
            setFilter(debouncedFilter);
            if (debouncedFilter && debouncedFilter !== ((ref = (0,getQueryObject/* default */.Z)(router)) === null || ref === void 0 ? void 0 : ref.search)) {
                var url = new URL(window.location.href);
                url.searchParams.set("search", debouncedFilter);
                window.history.pushState(null, "", url.toString());
            }
        }
    }, [
        debouncedFilter,
        setFilter,
        filter,
        router
    ]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        if (searching) {
            input.current.focus();
        } else {
            setFilter("");
            setLocalSearch("");
        }
    }, [
        searching
    ]);
    var containerClassName = {
        v1: (styles_module_default()).container,
        v2: (styles_module_default()).withBarContainer,
        mobile: (styles_module_default()).withBarContainerMobile
    }[props.layout];
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).search,
                onClick: function() {
                    (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.search);
                    setSearching(!searching);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdSearch */.vU7, {
                    size: 20
                })
            }),
            searching ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: input,
                        className: (styles_module_default()).input,
                        value: localSearch,
                        onChange: function(event) {
                            return setLocalSearch(event.target.value);
                        },
                        type: "text",
                        placeholder: t("order.labelSearchProduct")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).close,
                        onClick: function() {
                            return setSearching(!searching);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                            size: 20
                        })
                    })
                ]
            }) : props.children
        ]
    });
    if (props.layout === "v1") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: containerClassName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).inner,
                children: content
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            className: (styles_module_default()).inner,
            children: content
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/BrandBar/styles.module.css
var BrandBar_styles_module = __webpack_require__(46368);
var BrandBar_styles_module_default = /*#__PURE__*/__webpack_require__.n(BrandBar_styles_module);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/BrandBar/index.tsx




function BrandBar(props) {
    var imgSrc = get_default()(props, "brand.menuImage.url");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BrandBar_styles_module_default()).container,
        children: imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: props.brand.menuImage.url
        }) : null
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/styles.module.css
var Categories_styles_module = __webpack_require__(23568);
var Categories_styles_module_default = /*#__PURE__*/__webpack_require__.n(Categories_styles_module);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/BrandBar/styles.module.css
var Brands_BrandBar_styles_module = __webpack_require__(9474);
var Brands_BrandBar_styles_module_default = /*#__PURE__*/__webpack_require__.n(Brands_BrandBar_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/BrandBar/index.tsx




function BrandBar_BrandBar(props) {
    var imgSrc = get_default()(props, "brand.categoriesImage.url");
    return imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: (Brands_BrandBar_styles_module_default()).image,
        onClick: props.onClick,
        src: props.brand.categoriesImage.url
    }) : null;
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/index.tsx




function Categories(props) {
    if (!props.categories) return null;
    var lastBrandId = null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Categories_styles_module_default()).brandsContainer,
        children: props.categories.map(function(category) {
            var brand = null;
            if (category.brand && category.brand._id !== lastBrandId) {
                brand = category.brand;
                lastBrandId = brand._id;
            }
            var brandContent = brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBar_BrandBar, {
                brand: brand,
                onClick: function() {
                    props.onClick();
                    props.scrollTo(category._id);
                }
            }) : null;
            if (!category.brand && lastBrandId) {
                lastBrandId = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: brandContent
            }, category._id);
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/Dropdown/styles.module.css
var Dropdown_styles_module = __webpack_require__(93633);
var Dropdown_styles_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/Dropdown/index.tsx







function Dropdown(param) {
    var name = param.name, ref = param.ref, subCategories = param.subCategories, className = param.className, id = param.id;
    var items = subCategories.items;
    var ref1 = (0,react.useState)(false), active = ref1[0], setActive = ref1[1];
    var internalRef = (0,react.useRef)();
    var finalRef = ref || internalRef;
    var t = (0,esm/* useTranslation */.$G)("generic").t;
    var subMenuStyle = function() {
        if (!finalRef.current) {
            return {
                display: "none"
            };
        }
        var _current = finalRef.current, offsetHeight = _current.offsetHeight, offsetLeft = _current.offsetLeft;
        return {
            position: "absolute",
            top: offsetHeight,
            left: offsetLeft - 5
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Dropdown_styles_module_default()).container,
        onMouseEnter: function() {
            return setActive(true);
        },
        onMouseLeave: function() {
            return setActive(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/pedir/category/".concat(id),
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    ref: finalRef,
                    style: active ? {
                        color: "var(--primary-color)"
                    } : {},
                    className: className,
                    children: [
                        name,
                        items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdArrowDropDown */.gwH, {})
                    ]
                })
            }),
            active && items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Dropdown_styles_module_default()).subMenu,
                style: subMenuStyle(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Dropdown_styles_module_default()).internalContainer,
                    children: [
                        items.map(function(item, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/pedir/category/".concat(item._id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: classnames_default()((Dropdown_styles_module_default()).item, (Dropdown_styles_module_default()).grey, (Dropdown_styles_module_default()).clickable),
                                    children: item.name
                                })
                            }, idx);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/pedir/category/".concat(id),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: classnames_default()((Dropdown_styles_module_default()).item, (Dropdown_styles_module_default()).clickable),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (Dropdown_styles_module_default()).viewAll,
                                        children: [
                                            " ",
                                            t("fields.showAll"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdArrowForward */.hdK, {
                                        color: "red"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useIsStore.ts + 3 modules
var useIsStore = __webpack_require__(49343);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function Categories_Categories(props) {
    var activeCategoryId1 = props.activeCategoryId, categories = props.categories, layout = props.layout, onClick = props.onClick;
    var refs = (0,useRef/* default */.Z)({}).current;
    var container = (0,useRef/* default */.Z)();
    var isStore = (0,useIsStore/* default */.Z)();
    var offsetLeft = {
        v1: 40,
        v2: 50,
        mobile: 50
    }[layout];
    var scrollTo = function(activeCategoryId) {
        var activeElement = refs[activeCategoryId];
        if (!activeElement) return;
        (0,misc_scrollTo/* default */.Z)({
            element: container.current,
            left: activeElement.offsetLeft - offsetLeft
        });
    };
    (0,useEffect/* default */.Z)(function() {
        if (!activeCategoryId1) return;
        scrollTo(activeCategoryId1);
    }, [
        activeCategoryId1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Categories_styles_module_default()).container,
        ref: container,
        children: categories.map(function(category) {
            var childProps = {
                ref: refs[category._id],
                key: category._id,
                className: activeCategoryId1 === category._id ? (Categories_styles_module_default()).active : classnames_default()((Categories_styles_module_default()).category, __webpack_require__.g.isDarkBackground ? (Categories_styles_module_default()).clearText : (Categories_styles_module_default()).darkText)
            };
            return isStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, _objectSpread({}, childProps, {
                id: category._id,
                name: category.name,
                subCategories: category.subCategories
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", _objectSpread({}, childProps, {
                onClick: function() {
                    onClick();
                    props.scrollTo(category._id);
                },
                children: category.name
            }));
        })
    });
};

// EXTERNAL MODULE: ./src/data/fragments/products/productListInformation.ts
var productListInformation = __webpack_require__(94033);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/fragments/categories/orderCategory.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment orderCategory on Category {\n    _id\n    name\n    products {\n      _id\n      categories {\n        _id\n        internalName\n      }\n      modifiers {\n        _id\n        optional\n      }\n      ...productListInformation\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var orderCategory = ((0,lib["default"])(_templateObject(), productListInformation/* default */.Z));

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/index.tsx + 2 modules
var Product = __webpack_require__(14637);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/styles.module.css
var Category_styles_module = __webpack_require__(59540);
var Category_styles_module_default = /*#__PURE__*/__webpack_require__.n(Category_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






var _Component;
var Category = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Category, _superClass);
    var _super = _createSuper(Category);
    function Category() {
        _classCallCheck(this, Category);
        return _super.apply(this, arguments);
    }
    var _proto = Category.prototype;
    _proto.getProducts = function getProducts() {
        var _this = this;
        var productList = this.props.category.products.filter(function(product) {
            if (_this.props.hideNotAvailableProducts && product.isOutOfStock) {
                return false;
            }
            if (!product.availabilityAt) return false;
            if (product.availabilityAt.notAvailableMessage) return true;
            return !!product.availabilityAt.available;
        });
        if (this.props.sorting) {
            if (this.props.sorting.type === "price") {
                productList = orderBy_default()(productList, function(product) {
                    return product.availabilityAt.finalPrice;
                }, [
                    this.props.sorting.order
                ]);
            }
            if (this.props.sorting.type === "name") {
                productList = orderBy_default()(productList, [
                    "name"
                ], [
                    this.props.sorting.order
                ]);
            }
        }
        return productList;
    };
    _proto.renderProducts = function renderProducts() {
        var _this = this;
        var className = this.props.productsLayout === "compact" ? ({
            mobile: "col-xs-6",
            v1: "col-xs-6 col-md-3",
            v2: "col-xs-3 col-md-2"
        })[this.props.layout] : ({
            mobile: "col-xs-12",
            v1: "col-xs-12 col-md-6",
            v2: "col-xs-6 col-md-4"
        })[this.props.layout];
        className += " menuProductCol";
        return this.getProducts().map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* default */.Z, {
                    productsLayout: _this.props.productsLayout,
                    productCardDesign: _this.props.productCardDesign,
                    hidePrice: _this.props.hidePrice,
                    // @ts-expect-error ts-migrate(2739) FIXME: Type 'orderCategory_products' is missing the follo... Remove this comment to see the full error message
                    product: product,
                    menuId: _this.props.menuId
                })
            }, product._id);
        });
    };
    _proto.render = function render() {
        var category = this.props.category;
        if (this.getProducts().length === 0) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Category_styles_module_default()).container,
                id: "t111_".concat(category._id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Category_styles_module_default()).name,
                        children: category.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Category_styles_module_default()).products,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: this.renderProducts()
                        })
                    })
                ]
            })
        });
    };
    return Category;
}(_Component = react.Component);
Category.fragment = orderCategory;


// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Filters/index.tsx
var Filters = __webpack_require__(6991);
// EXTERNAL MODULE: ./src/helpers/misc/exactSearch.ts
var exactSearch = __webpack_require__(87714);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/getProducts.ts

function getProducts(products, filter, Fuse, sort) {
    var exact = (0,exactSearch/* default */.Z)(filter);
    var fuse = new Fuse(products, {
        fieldNormWeight: 1,
        keys: [
            {
                name: "name",
                weight: 1
            },
            {
                name: "nicknames",
                weight: 1
            },
            {
                name: "description",
                weight: 0.5
            }
        ],
        threshold: exact ? 0 : 0.45
    });
    var productList = fuse.search(filter).map(function(product) {
        return product.item;
    });
    return productList;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Loading/index.tsx
var Loading = __webpack_require__(31143);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/NoBrandDivider/styles.module.css
var NoBrandDivider_styles_module = __webpack_require__(65626);
var NoBrandDivider_styles_module_default = /*#__PURE__*/__webpack_require__.n(NoBrandDivider_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/NoBrandDivider/index.tsx



function NoBrandDivider(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NoBrandDivider_styles_module_default()).container
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx + 23 modules
var SelectProduct = __webpack_require__(56498);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/styles.module.css
var ProductsContent_styles_module = __webpack_require__(31616);
var ProductsContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductsContent_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/index.tsx
function ProductsContent_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsContent_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ProductsContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductsContent_getPrototypeOf(o1) {
    ProductsContent_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ProductsContent_getPrototypeOf(o1);
}
function ProductsContent_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ProductsContent_setPrototypeOf(subClass, superClass);
}
function ProductsContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductsContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductsContent_possibleConstructorReturn(self, call) {
    if (call && (ProductsContent_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ProductsContent_assertThisInitialized(self);
}
function ProductsContent_setPrototypeOf(o2, p1) {
    ProductsContent_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ProductsContent_setPrototypeOf(o2, p1);
}
var ProductsContent_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ProductsContent_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ProductsContent_createSuper(Derived) {
    var hasNativeReflectConstruct = ProductsContent_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ProductsContent_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ProductsContent_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ProductsContent_possibleConstructorReturn(this, result);
    };
}
























var _class;
var _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    typeof ProductsContentProps === "undefined" ? Object : ProductsContentProps
]), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function);
var ProductsContent = _class = (0,withScroll/* default */.Z)(_class = _dec1(_class = _dec((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    ProductsContent_inherits(ProductsContent, _Component);
    var _super = ProductsContent_createSuper(ProductsContent);
    function ProductsContent(props) {
        ProductsContent_classCallCheck(this, ProductsContent);
        var _this;
        _this = _super.call(this, props);
        _this.lastProductId = null;
        _this.categoriesRefs = {};
        _this.state = {
            scrollOffset: 0,
            filter: "",
            sorting: null,
            lastScroll: null,
            searchProducts: []
        };
        var productId = props.router.query.productId;
        if (productId) {
            _this.lastProductId = typeof productId === "string" ? productId : productId[0];
        }
        return _this;
    }
    var _proto = ProductsContent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var scrollCategorySlug = this.props.router.query.categoria;
        var search = this.props.router.query.search;
        if (scrollCategorySlug) {
            this.setScrollOnClick(scrollCategorySlug);
        }
        if (search) {
            this.setState({
                filter: search
            });
            this.memoizeProducts();
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var ref;
        this.setScrollToId();
        this.checkActiveCategory();
        this.scrollTo();
        var scrollCategorySlug = this.props.router.query.categoria;
        if (scrollCategorySlug && this.state.lastScroll !== scrollCategorySlug) {
            this.setScrollOnClick(scrollCategorySlug);
        }
        var search = this.props.router.query.search;
        if (search && search !== prevProps.router.query.search) {
            this.setState({
                filter: search
            });
        }
        // If either the query changed or the previous memoization attempt failed, memoize the products
        if (search && (search !== prevProps.router.query.search || !((ref = this.state.searchProducts) === null || ref === void 0 ? void 0 : ref.length))) {
            this.memoizeProducts();
        }
    };
    _proto.setScrollOnClick = function setScrollOnClick(category) {
        this.setState({
            scrollToSlug: category,
            lastScroll: category
        });
    };
    _proto.setScrollToId = function setScrollToId() {
        var categories = this.props.categories;
        var _state = this.state, scrollToSlug = _state.scrollToSlug, scrollTo1 = _state.scrollTo;
        if (!categories) return;
        if (!scrollToSlug || scrollTo1) return;
        var clean = function(text) {
            return text.toLowerCase().replace(/ /g, "-");
        };
        var scrollCategory = categories.items.find(function(item) {
            return slugify_default()(clean(item.name)) === clean(scrollToSlug);
        });
        if (scrollCategory) {
            this.setState({
                scrollTo: scrollCategory._id,
                scrollToSlug: null
            });
        }
    };
    _proto.getVisibleCategories = function getVisibleCategories() {
        if (!this.props.categories) return [];
        return this.props.categories.items.filter(function(category) {
            return category.products.filter(function(product) {
                if (!product.availabilityAt) return false;
                if (product.availabilityAt.notAvailableMessage) return true;
                return !!product.availabilityAt.available;
            }).length > 0;
        });
    };
    _proto.getCategoriesBarOffset = function getCategoriesBarOffset() {
        if (this.props.layout === "v1") {
            return 70;
        } else {
            return 70 + 50;
        }
    };
    _proto.scrollTo = function scrollTo2() {
        if (!this.props.categories) return;
        if (!this.state.scrollTo) return;
        if (!this.categoriesRefs[this.state.scrollTo]) {
            console.log("scroll to category not found");
            return;
        }
        if (!this.categoriesRefs[this.state.scrollTo].offsetTop) {
            var _this = this;
            console.log("scroll to category not mounted, trying again");
            setTimeout(function() {
                return _this.scrollTo();
            }, 400);
            return;
        }
        var top = this.categoriesRefs[this.state.scrollTo].offsetTop - this.getCategoriesBarOffset() - this.state.scrollOffset;
        (0,misc_scrollTo/* default */.Z)({
            top: top
        });
        this.setState({
            scrollTo: null
        });
    };
    _proto.checkActiveCategory = function checkActiveCategory() {
        var activeCategoryId = this.getActiveCategory();
        if (this.state.activeCategoryId !== activeCategoryId) {
            this.setState({
                activeCategoryId: activeCategoryId
            });
        }
    };
    _proto.getActiveCategory = function getActiveCategory() {
        if (!this.props.categories) return;
        var activeCategoryId = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.props.categories.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _step.value, categoryId = _value._id;
                var element = this.categoriesRefs[categoryId];
                if (!element) continue;
                var position = element.offsetTop;
                if (position - this.getCategoriesBarOffset() - 10 < this.props.scrollY) {
                    activeCategoryId = categoryId;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return activeCategoryId;
    };
    _proto.getSelectedProduct = function getSelectedProduct() {
        if (!this.props.categories) return null;
        var productId = this.lastProductId || this.props.router.query.productId;
        if (!productId) return null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.props.categories.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var products = _step.value.products;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var product = _step1.value;
                        if (product._id === productId) {
                            return product;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _proto.renderCategories = function renderCategories() {
        var _this = this;
        if (!this.props.categories) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
        var categories = this.getVisibleCategories();
        var lastBrandId = null;
        return categories.map(function(category) {
            var _this1 = _this;
            var brand = null;
            if (category.brand && category.brand._id !== lastBrandId) {
                brand = category.brand;
                lastBrandId = brand._id;
            }
            var dividerContent = !category.brand && lastBrandId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoBrandDivider, {}) : null;
            var brandContent = brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBar, {
                brand: brand
            }) : null;
            if (!category.brand && lastBrandId) {
                lastBrandId = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    brandContent,
                    dividerContent,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: function(ref) {
                            return _this1.categoriesRefs[category._id] = ref;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                            productsLayout: _this.props.productsLayout,
                            layout: _this.props.layout,
                            productCardDesign: _this.props.productCardDesign,
                            category: category,
                            menuId: _this.props.menuId,
                            hidePrice: _this.props.preferences.shouldHidePrice,
                            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                            select: function(select) {
                                return _this1.setState({
                                    select: select,
                                    open: true
                                });
                            },
                            sorting: _this.state.sorting,
                            hideNotAvailableProducts: _this.props.website.hideNotAvailableProducts
                        })
                    })
                ]
            }, category._id);
        });
    };
    _proto.renderSelect = function renderSelect() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct/* default */.Z, {
                product: this.getSelectedProduct(),
                storeId: this.props.storeId,
                open: !!(this.props.router.query.productId && this.getSelectedProduct()),
                menuId: this.props.preferences.menuId,
                preferences: this.props.preferences,
                close: function() {
                    var query = ProductsContent_objectSpread({}, (0,getQueryObject/* default */.Z)(_this.props.router));
                    delete query.productId;
                    _this.props.router.push({
                        pathname: "/pedir",
                        query: query
                    }, null, {
                        scroll: false
                    });
                }
            })
        });
    };
    _proto.renderBar = function renderBar() {
        var _this = this;
        var visibleCategories = this.getVisibleCategories();
        if (!visibleCategories.length) return;
        return this.props.website && this.props.website.isMultiBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories, {
            activeCategoryId: this.state.activeCategoryId,
            categories: this.getVisibleCategories(),
            scrollTo: function(scrollTo3) {
                return _this.setState({
                    scrollTo: scrollTo3,
                    scrollOffset: 120
                });
            },
            layout: this.props.layout,
            onClick: function() {
                return _this.setState({
                    filter: null
                });
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_Categories, {
            activeCategoryId: this.state.activeCategoryId,
            categories: this.getVisibleCategories(),
            scrollTo: function(scrollTo4) {
                return _this.setState({
                    scrollTo: scrollTo4
                });
            },
            layout: this.props.layout,
            onClick: function() {
                return _this.setState({
                    filter: null
                });
            }
        });
    };
    _proto.memoizeProducts = function memoizeProducts() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref1, categories, Fuse, allProducts, searchProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        categories = (ref = _this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1.items;
                        if (!(!categories || categories.length === 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return __webpack_require__.e(/* import() */ 4221).then(__webpack_require__.bind(__webpack_require__, 74221));
                    case 6:
                        Fuse = _ctx.sent.default;
                        allProducts = uniqBy_default()(flatten_default()(categories.map(function(cat) {
                            return cat.products;
                        })), "_id");
                        searchProducts = getProducts(allProducts, _this.state.filter, Fuse, _this.state.sorting);
                        if (!(searchProducts.length === 0)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        _this.setState({
                            searchProducts: searchProducts
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.renderSearchResults = function renderSearchResults() {
        var _this = this;
        if (!this.props.categories) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
        var category = {
            _id: "search",
            name: "Resultados",
            products: this.state.searchProducts
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
            productsLayout: this.props.productsLayout,
            layout: this.props.layout,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            category: category,
            menuId: this.props.menuId,
            hidePrice: this.props.preferences.shouldHidePrice,
            select: function(select) {
                return _this.setState({
                    select: select,
                    open: true
                });
            },
            productCardDesign: this.props.productCardDesign,
            sorting: this.state.sorting,
            hideNotAvailableProducts: this.props.website.hideNotAvailableProducts
        });
    };
    _proto.render = function render() {
        var _this = this;
        var productId = this.props.router.query.productId;
        if (productId) {
            this.lastProductId = typeof productId === "string" ? productId : productId[0];
        }
        var products = this.state.filter ? this.renderSearchResults() : this.renderCategories();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ProductsContent_styles_module_default()).container + " " + (ProductsContent_styles_module_default())["container_" + this.props.layout],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                        layout: this.props.layout,
                        filter: this.state.filter,
                        setFilter: function(filter) {
                            _this.setState({
                                filter: filter
                            });
                            if (filter) {
                                _this.memoizeProducts();
                            }
                        },
                        children: this.renderBar()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: (ProductsContent_styles_module_default()).containerLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductsContent_styles_module_default()).containerIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName/* default */.Z, {
                                preferences: this.props.preferences,
                                website: this.props.website,
                                isOnMenu: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProductsContent_styles_module_default()).containerFilter,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters/* default */.Z, {
                                    sorting: this.state.sorting,
                                    setSorting: function(sorting) {
                                        return _this.setState({
                                            sorting: sorting
                                        });
                                    }
                                })
                            })
                        })
                    ]
                }),
                this.props.layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        this.props.nextOpenDate,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        products
                    ]
                }) : products,
                this.renderSelect()
            ]
        });
    };
    return ProductsContent;
}(react.Component)) || _class) || _class) || _class) || _class;
/* harmony default export */ var Products_ProductsContent = ((0,next_router.withRouter)(ProductsContent));

// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
;// CONCATENATED MODULE: ./src/data/queries/categories/categoriesForWebsite.ts
function categoriesForWebsite_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function categoriesForWebsite_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                categoriesForWebsite_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                categoriesForWebsite_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function categoriesForWebsite_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function categoriesForWebsite_templateObject() {
    var data = categoriesForWebsite_taggedTemplateLiteral([
        "\n  query getCategoriesAndProductsWeb_cached($websiteId: ID, $menuId: ID, $format: String) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        ...orderCategory\n        brand {\n          _id\n          name\n          menuImage {\n            _id\n            url\n          }\n          categoriesImage {\n            _id\n            url\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    categoriesForWebsite_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = categoriesForWebsite_taggedTemplateLiteral([
        "\n  query getCategoriesAndProductsCPGsWeb_cached($websiteId: ID, $menuId: ID, $format: String) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        ...orderCategory\n        brand {\n          _id\n          name\n          menuImage {\n            _id\n            url\n          }\n          categoriesImage {\n            _id\n            url\n          }\n        }\n        subCategories {\n          items {\n            _id\n            name\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var categoriesForStoreQuery = (0,lib["default"])(categoriesForWebsite_templateObject(), orderCategory);
var categoriesForCPGQuery = (0,lib["default"])(_templateObject1(), orderCategory);
function getCategoriesForWebsite(_) {
    return _getCategoriesForWebsite.apply(this, arguments);
}
function _getCategoriesForWebsite() {
    _getCategoriesForWebsite = categoriesForWebsite_asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var websiteId, menuId, _format, format, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    websiteId = param.websiteId, menuId = param.menuId, _format = param.format, format = _format === void 0 ? "webp" : _format;
                    _ctx.next = 3;
                    return getClient().query({
                        query: categoriesForStoreQuery,
                        variables: {
                            websiteId: websiteId,
                            menuId: menuId,
                            format: format
                        }
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.categories);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCategoriesForWebsite.apply(this, arguments);
}
function getCategoriesForCPGWebsite(_) {
    return _getCategoriesForCPGWebsite.apply(this, arguments);
}
function _getCategoriesForCPGWebsite() {
    _getCategoriesForCPGWebsite = categoriesForWebsite_asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var websiteId, menuId, _format, format, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    websiteId = param.websiteId, menuId = param.menuId, _format = param.format, format = _format === void 0 ? "webp" : _format;
                    _ctx.next = 3;
                    return getClient().query({
                        query: categoriesForCPGQuery,
                        variables: {
                            websiteId: websiteId,
                            menuId: menuId,
                            format: format
                        }
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.categories);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCategoriesForCPGWebsite.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var apollo_hooks_lib = __webpack_require__(25074);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/useCategoriesAndProducts.ts




function useCategoriesAndProducts(param) {
    var websiteId = param.websiteId, menuId = param.menuId, format = param.format, _preloadedCategories = param.preloadedCategories, preloadedCategories = _preloadedCategories === void 0 ? {
        items: []
    } : _preloadedCategories;
    var isStore = (0,useIsStore/* default */.Z)();
    var query = isStore ? categoriesForCPGQuery : categoriesForStoreQuery;
    // On the serverside, we skip this query and return the categories loaded at getStaticProps
    // These categories are obtained from the store default menu
    var result = (0,apollo_hooks_lib.useApolloQuery)({
        query: query,
        variables: {
            websiteId: websiteId,
            menuId: menuId,
            format: format
        },
        partial: true,
        omit: (0,isServerSide/* default */.Z)()
    });
    if ((0,isServerSide/* default */.Z)() || !result.data) {
        return {
            categories: preloadedCategories
        };
    }
    return result;
};

// EXTERNAL MODULE: ./src/data/queries/stock/getOutOfStockProductsInList.ts
var getOutOfStockProductsInList = __webpack_require__(74207);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/useSetOutOfStockProducts.ts




function useSetOutOfStockProducts(param) {
    var websiteId = param.websiteId, categories = param.categories, storeId = param.storeId, deliverAt = param.deliverAt;
    var productsIds = [];
    var cats = categories ? categories.items : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = category.products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var product = _step1.value;
                    productsIds.push(product._id);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var outOfStockIds = (0,apollo_hooks_lib.useApolloQuery)({
        query: getOutOfStockProductsInList/* getOutOfStockProductsInListQuery */.q,
        variables: {
            websiteId: websiteId,
            productsIds: uniq_default()(productsIds),
            storeId: storeId,
            deliverAt: deliverAt
        },
        partial: true,
        omit: productsIds.length === 0 || !storeId || (0,isServerSide/* default */.Z)()
    }).outOfStockIds;
    if (!outOfStockIds || !outOfStockIds.length) return {
        outOfStockIds: []
    };
    return {
        outOfStockIds: outOfStockIds
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/index.tsx
function Products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Products_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Products_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function Products(props) {
    var menuId = props.menuId, storeId = props.storeId, deliverAt = props.deliverAt, preloadedCategories = props.preloadedCategories, website = props.website;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var format = (0,hasWebpSupport/* default */.Z)() ? "webp" : "jpeg";
    var categories = useCategoriesAndProducts({
        websiteId: websiteId,
        menuId: menuId,
        format: format,
        preloadedCategories: preloadedCategories
    }).categories;
    var outOfStockIds = useSetOutOfStockProducts({
        websiteId: websiteId,
        categories: categories,
        storeId: storeId,
        deliverAt: deliverAt
    }).outOfStockIds;
    var memoizedCategories = (0,react.useMemo)(function() {
        if (!((categories === null || categories === void 0 ? void 0 : categories.items) && outOfStockIds)) return categories;
        var newCategories = {
            items: []
        };
        newCategories.items = categories.items.map(function(category) {
            var newProducts = category.products.map(function(product) {
                return Products_objectSpread({}, product, {
                    isOutOfStock: outOfStockIds.includes(product._id)
                });
            });
            return Products_objectSpread({}, category, {
                products: newProducts
            });
        });
        return newCategories;
    }, [
        outOfStockIds,
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_ProductsContent, Products_objectSpread({}, props, {
        website: website,
        categories: memoizedCategories
    }));
};


/***/ }),

/***/ 68732:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line":"_2z8h9VIqWQIynSA7ebMiuS","after":"_2S8rrYzw8a9vQ4yD7xchNy","shimmer":"Spe-oMbOnLeeY3Yo0Jddo"};

/***/ }),

/***/ 42653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SumNs9G2VhZ4R6NtF15oq categoriesBar backgroundColor backgroundBorderColor","inner":"_25HrABaLHeG06s6mkOpAm7","withBarContainer":"bD81skAySjzC_ASwSkC2b _1SumNs9G2VhZ4R6NtF15oq categoriesBar backgroundColor backgroundBorderColor","withBarContainerMobile":"_1CLebVj6of1hV8SdIjf6Mo _1SumNs9G2VhZ4R6NtF15oq categoriesBar backgroundColor backgroundBorderColor","search":"_2wKyk1TmtQj-2vyLxoIkyd","close":"_1IBcPTy_3aqJ-2HW-VgDYK _2wKyk1TmtQj-2vyLxoIkyd","input":"HleMUJooq_sNd-eQeWXcX backgroundColor textColor"};

/***/ }),

/***/ 46368:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_218KRUp_aKHkYT4W5LYIr3"};

/***/ }),

/***/ 9474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"_2n863Ch04Xm6I8qOb9IjvQ"};

/***/ }),

/***/ 93633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NJs8vcV8_JP1C6oknN0K3","subMenu":"_2yiHXcXaO-evCTfE4IXKJK","internalContainer":"sYm88FtY5wGLcyTFoWkdk","item":"K6aBAfOuNDTGqNFIP-T95","active":"_31EtZOEAQ1bdYZHv88zS9x","grey":"_2DpU06ipa0YUR4chynUSYN","viewAll":"_1mH2NZ6PCPVOkZ7wvAgsbf","clickable":"_2F4NXQIvtpGitxy5HqqN-7"};

/***/ }),

/***/ 23568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Y2myTiF1rA1_xi6R74uFB","brandsContainer":"_101cBxD0_Oz4Bfa41WR_6y _3Y2myTiF1rA1_xi6R74uFB","category":"PMmYJcjwi0OVUNEI3wkNH categoriesBarItem","clearText":"_4PCTlb8gArXihRSnEAHca","darkText":"_3JaOd-lSXh8Z8Ocy4x9ZN-","active":"_1FOW7HfIed5hxwHYDkhbXo PMmYJcjwi0OVUNEI3wkNH categoriesBarItem categoriesBarItemActive textColor"};

/***/ }),

/***/ 59540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jU7LHQAFgsjy0t2QSVFUG","name":"fahAOBEtcJXL_vQiK4fah appTitle","products":"Jw-GQ1r-mZqgls-nIWFlc","menuProductCol":"_2gA2q6LFKNg_089WQ7zI7k"};

/***/ }),

/***/ 18783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_-92tf-wuo2Yx2KOPmRavk","order":"_3Uny8y42CnRrBgpzjd5MXw"};

/***/ }),

/***/ 65626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3sS7KGUyRNVeZF9rsBhlDv"};

/***/ }),

/***/ 31616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MGVMHYuV2u5Mnd4iJrB5z","order":"_1rc5Zr7uGJ08A7khxcq_Cw","container_v2":"_3FD032u_YFLQKVcG3ziO6E","containerIcon":"_2Oh-2Bzj3YvGTCi-dCDB8E","containerLabel":"VCCkn5d7s1AgefhPPUSFA","containerFilter":"_4k1tbxlHpljsPDTqQ7AH4"};

/***/ })

}]);